import { useEffect, useState } from "react";
import { getBackendUrl } from "../src/utils/preview";

type BackendVersion = {
  commitHash: string;
  time: string;
};

export const useBackendVersion = () => {
  const [version, setVersion] = useState<BackendVersion | undefined>();

  useEffect(() => {
    fetch(`${getBackendUrl().replace(/\/$/, "")}/cashier/__version__`)
      .then((res) => res.json() as Promise<BackendVersion>)
      .then(setVersion)
      .catch((err) => {
        console.error("Failed to fetch backend version", err);
      });
  }, []);

  return version;
};
